// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"5f405c74","348":"1187af15","472":"f3ff5c38","552":"daba7969","888":"1187af15"}[chunkId] + ".chunk.css";
};